import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top on every route change. React Router does NOT do this by
// default, which causes deep product pages to open at the previous page's
// scroll offset.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}
